import { Headers, HttpMethod } from '../../types/types';
import { fetcher } from '../../utils/fetchers/fetcher';
import { resolveApiPath } from '../../utils/resolveApiPath';

export const requestDatasetAction = (
  api: string,
  method: HttpMethod,
  token: string | null,
  forceHeader?: string,
  additionalHeaders?: Headers
): Promise<any> =>
  fetcher<any>(
    resolveApiPath(api),
    method,
    token,
    forceHeader,
    undefined,
    undefined,
    additionalHeaders
  );
